import React, { useState, useEffect } from "react";
import { Button, Typography, Box, Grid, IconButton, Link, Divider } from "@mui/material";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom"; // Floor Icon
import { LabelIcons } from "../newDashboard/Svg/labelIcons";
import CustomTooltip from "../newDashboard/tooltip";
import { CircleSVG } from "../mainViewComponent/Svg";
import ImageMapper from "react-img-mapper";
import { RootState, useAppSelector } from "../../store/store";
import { getDeviceStrokeColor } from "../../helper/service";
import { nanoid } from "nanoid";
import __ from "underscore";
import FloorCardsEmap from "./floorCardsEmap";
import ThreeDView from "../newDashboard/ThreeDView";

interface MainviewProps {
  selectedFacility: any;
  floorData: any;
  handleGetSummaryData: any;
  currentFacilityData?: any;
}

interface ImageWIdth {
  [key: string]: number;
}

export type DeviceColors = {
  fcl: string;
  flr: string;
  loc: string;
  stm: string;
  uni: string;
  pk: string;
  sk: string;
  id: string;
  location_name: string;
  tenantCode: string;
  created_at: string;
  updated_at: string;
  deviceImage: string;
  deviceImageUrl: string;
  color: string;
};

export const colorIndexData: any = {
  5: "#000000",
  4: "#871014",
  3: "#FFEF5C",
  2: "#FFEF5C",
  1: "#98E565",
  0: "#FFFFFF",
};

export const defaultLabelColor = "#4e4e4e";

const MapViewFacility: React.FC<any> = ({
  selectedFacility,
  floorData,
  currentFacilityData,
  handleGetSummaryData,
  currentFloor,
  setCurrentFloor,
  roomDeviceCountData,
  floorWithRoomCounts,
  floorDeviceCount,
  dashsummeryprops,
  currentRoom,
  locationsList,
  dashboardInterval,
  variant,
  sideOverviewData,
  tenantData,
  mapViewType
}) => {

  const [hoveredArea, setHoveredArea] = useState<any>({});
  const { themeMode } = useAppSelector((state) => state.themeSlice);
  const [imageWidth, setImageWidth] = useState<ImageWIdth>({});
  const [configDataNew, setconfigDataNew] = useState<any>([]);
  const [selectedFloor, setSelectedFloor] = useState<any>({ name: "all" });
  const [deviceColors, setDeviceColors] = useState<{
    [key: string]: Partial<DeviceColors>;
  }>({});
  const [files, setFiles] = useState<any>({
    base64: "",
    path: "",
    name: "",
    size: "",
    type: "",
  });
  const { eventMapList } = useAppSelector((state: RootState) => state.eventMapSlice);
  const { configureListNew } = useAppSelector(
    (state: RootState) => state.deviceSlice
  );
  const { detailMeasurementsList }: any = useAppSelector(
    (state) => state.substanceSlice
  );
  const { deviceList } = useAppSelector((state: RootState) => state.deviceSlice);

  console.log("eventMapList::1", floorData, eventMapList);


  useEffect(() => {
    setDeviceColors(() => {
      let data = {};
      configureListNew.map((device: any) => {
        const deviceColor = sideOverviewData[device?.flr]?.find(
          (color: any) => color?.key === device?.sk
        );
        data = {
          ...data,
          [device?.sk]: {
            ...device,
            id: device?.sk,
            color: ["-Infinity", undefined].includes(deviceColor?.colorOrder)
              ? "#FFFFFF"
              : colorIndexData[deviceColor?.colorOrder],
          },
        };
      });
      return data;
    });
  }, [configureListNew, sideOverviewData]);


  //Convert Image url to base64 image
  async function toDataUrl(url: any) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = function () {
        reject(new Error("Failed to load image"));
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  }

  function hexToRgb(hex: any, isDevice?: any) {
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex?.replace(
      shorthandRegex,
      function (m: any, r: any, g: any, b: any) {
        return r + r + g + g + b + b;
      }
    );
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const opacity = isDevice ? 1 : 0.5;
    return result
      ? "rgba(" +
      [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ] +
      ", " +
      opacity +
      " )"
      : null;
  }

  const getRoomDeviceCoords = (roomCoords: any, deviceIdx: any) => {
    let increment = 20;
    let decrement = 20;
    const { areaLeft, areaTop, areaRight, areaBottom } = roomCoords;

    const areaWidth = areaRight - areaLeft;
    const areaHeight = areaBottom - areaTop;

    // Calculate the average of width and height to use as a reference for dotRadius
    const referenceSize = (areaWidth + areaHeight) / 2;

    // Define your desired fraction as a percentage of the reference size
    const fractionOfReferenceSize = 0.08; // For example, 8% of the reference size

    // Calculate the dotRadius
    const dotRadius = referenceSize * fractionOfReferenceSize;

    switch (deviceIdx) {
      case 0:
        return [
          (areaLeft + areaRight) / 2,
          (areaTop + areaBottom) / 2,
          dotRadius,
        ];
      case 1:
        return [areaLeft + increment, (areaTop + areaBottom) / 2, dotRadius];
      case 2:
        return [areaRight - decrement, (areaTop + areaBottom) / 2, dotRadius];
      case 3:
        return [(areaLeft + areaRight) / 2, areaTop + increment, dotRadius];
      case 4:
        return [areaRight - decrement, areaTop + increment, dotRadius];
      case 5:
        return [areaLeft + increment, areaTop + increment, dotRadius];
      case 6:
        return [(areaLeft + areaRight) / 2, areaBottom - decrement, dotRadius];
      case 7:
        return [areaRight - decrement, areaBottom - decrement, dotRadius];
      case 8:
        return [areaLeft + increment, areaBottom - decrement, dotRadius];
      default:
        return [];
    }
  };

  useEffect(() => {
    configDataNew.forEach((val: any) => {
      if (val?.files?.base64) {
        getWidth(`mapImage-${val?.key}`, val?.files?.base64, val?.key);
      }
    });
  }, [configDataNew]);

  useEffect(() => {
    setImageWidth({});
    const fetchData = async () => {

      console.log("configDataNew ::", configDataNew);

      const tempFloorAr = await Promise.all(
        //Loop over Floor
        floorData.map(async (l: any) => {
          const floorDatas =
            floorWithRoomCounts.find((f: any) => f?.key === l?.value) || {}; //Get Floor Data
          const floorDevices = floorDeviceCount?.[l?.value] || [];
          const isUnit = l?.is_unit || false;
          const prefix = l?.prefix || "";
          const room = l?.rooms || [];

          let obj = {
            ...floorDatas,
            facility: selectedFacility?.key,
            floor: l.key,
            floorName: l.name,
            floorDeviceCount: floorDevices,
            section: l,
            prefix: prefix,
            is_unit: isUnit,
            rooms: room,
            randomKey: nanoid(),
          };

          if (!obj.is_unit) {
            //Getting floor devices
            const floorDevicesFiltered = configureListNew.filter(
              (item: any) => item.flr == obj.floor
            );
            const newFloor = floorDevicesFiltered.map((d: any) => {
              let deviceSk = d.sk;
              const getClrData =
                sideOverviewData?.[obj.floor]?.find(
                  (l: any) => l?.key === deviceSk
                ) || {};
              return {
                ...d,
                index:
                  getClrData?.colorOrder == "-Infinity" ||
                    getClrData?.colorOrder === undefined
                    ? 0
                    : getClrData?.colorOrder,
              };
            });
            obj.device = newFloor;
          } else {
            //prepare for all devices exist in different rooms of any floor in the case of unit
            const allUnitDevices: any = [];
            obj.floorDeviceCount?.forEach((f: any) => {
              f.device_keys?.forEach((dKey: any) => {
                const deviceInfo = configureListNew.find(
                  (l: any) => l?.sk === dKey
                );
                const deviceFloor = deviceInfo?.flr;
                const getClrData =
                  sideOverviewData?.[deviceFloor]?.find(
                    (l: any) => l?.key === dKey
                  ) || {};
                const deviceObj = {
                  ...deviceInfo,
                  index: getClrData?.colorOrder,
                };
                allUnitDevices.push(deviceObj);
              });
            });
            obj.device = allUnitDevices;
          }

          if (eventMapList?.getEventMap?.length) {
            const data =
              eventMapList?.getEventMap?.find(
                (item: any) => item.sk == obj.floor
              ) || {};
            if (data?.image_data) {
              let jsondata = JSON.parse(data?.image_data);
              obj.pk = data.pk;
              obj.allMarks = jsondata;
              const myBase64 = await toDataUrl(data?.image_map_data);
              const fileObj = { ...files, base64: myBase64 };
              obj.files = fileObj;
              console.log("eventMapList ::1", jsondata, obj);
            }
            console.log("eventMapList ::2", l, data, data?.image_data, obj);
          }

          //Creating imgMarkers
          if (obj?.allMarks && Object.keys(obj?.allMarks).length > 0) {
            let area: any = [];
            //Loop through all markers
            Object.keys(obj?.allMarks).forEach((id: any) => {
              const areaRoomId = id; //room id
              obj.allMarks[id].forEach((row: any) => {
                //If it is room markers then go to inside
                if (row?.type === "R" || typeof row?.type === "undefined") {
                  const isRoomExist = obj?.rooms?.filter(
                    (l: any) => l?.key === areaRoomId
                  );
                  console.log("eventMapList ::0isRoomExist", row, obj?.rooms, isRoomExist);
                  if (!__.isEmpty(isRoomExist)) {
                    const areaLeft = Math.round(row.left);
                    const areaTop = Math.round(row.top);
                    const areaRight =
                      Math.round(row.left) + Math.round(row.width);
                    const areaBottom =
                      Math.round(row.top) + Math.round(row.height);
                    const allDeviceList = [...obj.device];

                    //To find devices for particular room
                    const roomDevices = allDeviceList.filter(
                      (l) => l?.loc === areaRoomId
                    );

                    //To find wrost device index for setting room marker color
                    const deviceIndex = roomDevices.reduce((indices, item) => {
                      if (
                        item.index !== "-Infinity" &&
                        item.index !== undefined
                      )
                        indices.push(item.index);
                      return indices;
                    }, []);
                    const maxDeviceIndex: any = Math.max(...deviceIndex);

                    //prepare room marker
                    let arr = {
                      shape: "rect",
                      type: "R",
                      coords: [areaLeft, areaTop, areaRight, areaBottom],
                      fillColor:
                        maxDeviceIndex == "-Infinity" ||
                          maxDeviceIndex === undefined
                          ? hexToRgb("#FFFFFF")
                          : hexToRgb(colorIndexData[maxDeviceIndex]),
                      preFillColor:
                        maxDeviceIndex == "-Infinity" ||
                          maxDeviceIndex === undefined
                          ? hexToRgb("#FFFFFF")
                          : hexToRgb(colorIndexData[maxDeviceIndex]),
                      strokeColor: "#577EC6",
                      lineWidth: 3,
                      description: `${row.roomName}`,
                      roomName: `${row.roomName}`,
                      locationRoom: areaRoomId,
                    };

                    const tempDevice: any = [];
                    roomDevices.forEach((l, idx) => {
                      const roomCoordsObj = {
                        areaLeft,
                        areaTop,
                        areaRight,
                        areaBottom,
                      };

                      const deviceSk = l?.sk;
                      const getDeviceMarks =
                        obj?.allMarks?.[deviceSk]?.[0] || [];

                      let deviceCoords: any = [];
                      //If device marker is mapped on E-map Setup
                      if (!__.isEmpty(getDeviceMarks)) {
                        // Calculate the center of the ellipse (circle)
                        const centerX =
                          getDeviceMarks.left + getDeviceMarks.width / 2;
                        const centerY =
                          getDeviceMarks.top + getDeviceMarks.height / 2;

                        // Calculate the radius of the circle (assuming the ellipse is a circle)
                        const radius =
                          Math.min(
                            getDeviceMarks.width,
                            getDeviceMarks.height
                          ) / 2;

                        // Generate the 'coords' string for the circle shape
                        deviceCoords = [centerX, centerY, radius];
                      } else {
                        //When device marker is not mapped on E-map setup page then get random position of device marker
                        deviceCoords = getRoomDeviceCoords(roomCoordsObj, idx);
                      }

                      //prepare device marker
                      const deviceDot = {
                        id: idx,
                        deviceLocation: l?.location_name || "",
                        locationRoom: areaRoomId,
                        coords: deviceCoords,
                        shape: "circle",
                        type: "device",
                        fillColor:
                          l?.index == "-Infinity" || l?.index === undefined
                            ? "#FFFFFF"
                            : hexToRgb(colorIndexData[l?.index], true),
                        preFillColor:
                          l?.index == "-Infinity" || l?.index === undefined
                            ? "#FFFFFF"
                            : hexToRgb(colorIndexData[l?.index], true),
                        strokeColor: getDeviceStrokeColor(
                          l?.index,
                          maxDeviceIndex
                        ),
                        lineWidth: 5,
                      };
                      tempDevice.push(deviceDot);
                      area.push(deviceDot); //Push device dot
                    });
                    area.push(arr); //push room marker area
                    area.push(...tempDevice); //push room marker area again for display tooltip on hover
                  }
                }
              });
            });
            obj.imgMarkers = {
              name: "my-map-" + nanoid(),
              areas: area,
            };
            console.log("eventMapList ::0imgMarkers", obj.imgMarkers, obj?.allMarks, obj);
          }
          return obj;
        })
      );
      tempFloorAr?.sort((a: any, b: any) => a.is_unit - b.is_unit); //display floor first and then unit section
      console.log("tempFloorAr ::", tempFloorAr);

      setconfigDataNew(tempFloorAr);
    };

    fetchData();
  }, [
    floorData?.length,
    floorDeviceCount,
    roomDeviceCountData,
    detailMeasurementsList,
    tenantData,
    sideOverviewData,
  ]);


  const handleFloorSelect = (floorId: string) => {
    setSelectedFloor({ name: floorId });
    // handleGetSummaryData(floorId);
  };

  const getWidth = (imageDiv: any, imageBase: any, index: any) => {
    if (imageWidth[index]) {
      return false;
    }
    const parentDiv: any = document.getElementById(imageDiv);
    if (!parentDiv) return;
    let parentWidth: number = parentDiv?.offsetWidth;

    // Create an image element
    const img = new Image();

    // Set the src attribute to the Base64-encoded image data
    img.src = imageBase;
    let height = 0;
    let width = 0;

    // Wait for the image to load
    img.onload = function () {
      // Once the image is loaded, you can access its height and width
      height = img.naturalHeight;
      width = img.naturalWidth;

      let ratio = width / height;

      if (height > 320) {
        parentWidth = ratio * 320;
      }
      if (!Object.keys(imageWidth).includes(index)) {
        setImageWidth({ ...imageWidth, [index]: parentWidth });
      }
    };

    return parentWidth;
  };

  const handleClickFloor = (item: any) => {
    // if (item?.name === "all") {
    //   setCurrentBreadCrumb("dashboard");
    // } else {
    //   setCurrentBreadCrumb("overview");
    // }
    // setSelectedFloor(item);

    // if (item?.name !== "all") {
    //   if (item?.imgMarkers) {
    //     item = [...floorWithRoomCounts]?.find(
    //       (x: any) => x?.key === item?.floor
    //     );
    //   }
    //   getFloorRoomsOrOverviewPage(item, false); //set for List view so when switch to list view then it open same floor
    // }
  };

  const load = () => { };

  const clicked = (area: any, room: any) => {
    const roomId = area?.locationRoom;
    const getRoom = room?.roomData.find((l: any) => l.key === roomId);
    console.log(area, room, "getRoom");

    if (roomId && getRoom) {
      handleGetSummaryData("loc", area.locationRoom)
    }
  };

  const enterArea = (area: any, val: any) => {
    setHoveredArea({ ...hoveredArea, [val?.floor]: area });
  };

  //When we leave room or device marker area
  const leaveArea = (area: any) => {
    setHoveredArea({});
  };

  const getParentWidth = (width: number) => {
    switch (true) {
      case (window?.innerWidth < 400):
        return 250;
      case (window?.innerWidth < 600):
        return 400;
      case (window?.innerWidth < 800):
        return 600;
      default:
        return width;
    }
  }

  const redirectToOverview = (deviceLocationId: string, facilityId: string) => {
    const facility = configDataNew.find(
      (value: any) => value?.key === facilityId
    );
    const getRoom = facility?.roomData.find(
      (l: any) => l.key === deviceLocationId
    );
    handleGetSummaryData("loc", getRoom?.key);
  };

  return (
    <Box sx={{ padding: 2 }}>
      {mapViewType !== "3D" && (floorData.length > 0 ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap", // Keep in a single row
            overflowX: "auto", // Enable horizontal scroll if needed
            gap: 2, // Space between buttons
            p: 1
          }}
        >
          {/* "All Floors" Button */}
          <Button
            variant={selectedFloor.name === "all" ? "contained" : "outlined"}
            onClick={() => handleFloorSelect("all")}
            sx={{
              textTransform: "none",
              fontSize: "12px",
              padding: "8px 16px",
              height: "32px",
              width: "auto",
              borderRadius: 16,
              //   fontWeight: selectedFloor === "all" ? "bold" : "normal",
            }}
          >
            All Floors
          </Button>

          {/* Floor Buttons */}
          {floorData.map((floor: any) => (
            <Button
              key={floor.id}
              variant={selectedFloor.name === floor.name ? "contained" : "outlined"}
              startIcon={<LabelIcons
                type={floor?.type}
                isUnit={floor?.is_unit}
                bgcolor={
                  selectedFloor?.name === floor?.name &&
                    themeMode !== "dark"
                    ? "#FFFFFF"
                    : defaultLabelColor
                }
              />}
              onClick={() => handleFloorSelect(floor.name)}
              sx={{
                textTransform: "none",
                fontSize: "12px",
                padding: "8px 16px",
                height: "32px",
                width: "auto",
                borderRadius: 16,
                // fontWeight: selectedFloor === floor.id ? "bold" : "normal",
              }}
            >
              {floor.name}
            </Button>
          ))}
        </Box>
      ) : (
        <Typography variant="body1">No floor data available.</Typography>
      ))}
      <Divider sx={{ m: 2 }} />
      {mapViewType === "3D" ? (
        <ThreeDView
          redirectToOverview={redirectToOverview}
          deviceColors={deviceColors}
          spaceId={currentFacilityData?.space_id}
          tenantCode={tenantData?.tenantCode}
          facilityId={currentFacilityData?.key}
        />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Grid
            sx={{
              ml: "1%",
              gap: "50px",
              paddingBottom: configDataNew?.length <= 2 ? "4%" : "0px",
            }}
            container
          >
            {configDataNew.length > 0 &&
              configDataNew
                .filter((val: any) =>
                  selectedFloor.name !== "all"
                    ? val.floorName === selectedFloor.name
                    : true
                )
                .map((val: any, index: number) => {
                  getWidth(
                    `mapImage-${val?.key}`,
                    val?.files?.base64,
                    val?.key
                  );

                  // Click handler for selecting floor
                  const handleClick = () => {
                    handleClickFloor({
                      ...val,
                      name: val?.floorName,
                    });
                    localStorage.setItem("whoKeyClicked", "floor");
                  };

                  return (
                    <Grid item xs={12} md={5.7}>
                      <Box
                        className="alignItms"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        {/* Display floor name */}
                        <LabelIcons
                          type={
                            currentFacilityData?.type === "FU" &&
                              val?.type == "L"
                              ? "FU"
                              : val?.type
                          }
                          isUnit={val?.is_unit}
                        />
                        <Typography
                          onClick={() => handleGetSummaryData(
                            "flr",
                            val?.key
                          )}
                          sx={{
                            p: 2,
                            pl: 0,
                            fontWeight: "bold",
                            fontSize: "1rem",
                            ":hover": {
                              cursor: "pointer",
                              textDecoration: "underline",
                            },
                          }}
                        >{`${val?.floorName}`}</Typography>
                        <>
                          {/* Display device count */}
                          {val?.floorDeviceCount?.map(
                            (newItem: any, idx: number) => (
                              <React.Fragment>
                                {newItem.deviceCount > 0 && (
                                  <Box
                                    sx={{
                                      cursor: "pointer",
                                      display: "flex",
                                      mt: "1%",
                                    }}
                                    onClick={() =>
                                      handleGetSummaryData(
                                        "flr",
                                        val?.key
                                      )
                                    }
                                  >
                                    <Typography>
                                      <CustomTooltip
                                        title={
                                          <span>
                                            {`Go to summary`}
                                            <br />
                                            <span
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                              }}
                                            >
                                              <LabelIcons
                                                bgcolor={"#FFFFFF"}
                                                isUnit={val?.is_unit}
                                                type={val?.type}
                                                size={18}
                                              />
                                              {`${val?.floorName}`}
                                            </span>
                                          </span>
                                        }
                                      >
                                        <IconButton
                                          sx={{ paddingTop: "0px" }}
                                        >
                                          <CircleSVG
                                            getnumber={`${newItem?.deviceCount}`}
                                            bgcolor={
                                              colorIndexData[
                                              newItem?.colorOrder
                                              ]
                                            }
                                            fontColor={""}
                                            themeMode={themeMode}
                                          />
                                        </IconButton>
                                      </CustomTooltip>
                                    </Typography>
                                  </Box>
                                )}
                              </React.Fragment>
                            )
                          )}
                        </>
                      </Box>
                      {val?.files?.base64 ? (
                        selectedFloor.name === "all" ? (
                          //When listing all floors
                          <Box
                            id={`mapImage-${val?.key}`}
                            className="container"
                            sx={{
                              overflow: 'auto',
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "2px 2px 4px 2px #ddd",
                              minHeight: "320px",
                              // zIndex: 1,
                              position: "relative",
                              ":hover": {
                                boxShadow: "4px 4px 6px 4px #ddd",
                              },
                            }}
                          >
                            <Link onClick={handleClick}>
                              {imageWidth[val?.key] && (
                                <>
                                  <ImageMapper
                                    src={val?.files?.base64}
                                    map={val?.imgMarkers}
                                    onLoad={() => load()}
                                    onClick={(area) =>
                                      clicked(area, val)
                                    }
                                    onMouseEnter={(area) =>
                                      enterArea(area, val)
                                    }
                                    onMouseLeave={(area) =>
                                      leaveArea(area)
                                    }
                                    responsive={true}
                                    stayHighlighted={true}
                                    parentWidth={getParentWidth(imageWidth[val?.key])}
                                  // parentWidth={
                                  //   imageWidth[val?.key] || 600
                                  // }

                                  />
                                  {hoveredArea[val?.floor] && (
                                    <Box
                                      className="tooltip"
                                      sx={{
                                        position: "absolute",
                                        backgroundColor: "#577EC6",
                                        color: "#FFFFFF",
                                        padding: "1%",
                                        borderRadius: "5px",
                                        // width: "500px",
                                        minWidth: "200px",
                                        maxWidth: "300px", // Set a maximum width
                                        whiteSpace: "normal", // Ensure the text wraps
                                        wordWrap: "break-word", // Break words if necessary
                                        zIndex: 999, // Ensure the tooltip appears above other elements
                                        left: hoveredArea[val?.floor]?.center[0] + 50, // Adjust within ImageMapper
                                        top: hoveredArea[val?.floor]?.center[1] + 100, // Adjust above the area
                                        transform: "translate(-50%, -100%)", // Ensure proper placement
                                      }}
                                    >
                                      <span>
                                        {`Go to summary`}
                                        <br />
                                        {hoveredArea[val?.floor]
                                          ?.roomName && (
                                            <span
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                              }}
                                            >
                                              <LabelIcons
                                                bgcolor={"#FFFFFF"}
                                                type={
                                                  hoveredArea[val?.floor]
                                                    ?.type
                                                }
                                                size={
                                                  hoveredArea[val?.floor]
                                                    ?.type === "device"
                                                    ? 25
                                                    : 18
                                                }
                                              />
                                              {
                                                hoveredArea[val?.floor]
                                                  ?.roomName
                                              }
                                            </span>
                                          )}
                                        {hoveredArea[val?.floor]
                                          ?.deviceLocation && (
                                            <span
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                              }}
                                            >
                                              <LabelIcons
                                                bgcolor={"#FFFFFF"}
                                                type={
                                                  hoveredArea[val?.floor]
                                                    ?.type
                                                }
                                                size={
                                                  hoveredArea[val?.floor]
                                                    ?.type === "device"
                                                    ? 25
                                                    : 18
                                                }
                                              />
                                              {
                                                hoveredArea[val?.floor]
                                                  ?.deviceLocation
                                              }
                                            </span>
                                          )}
                                      </span>
                                    </Box>
                                  )}
                                </>
                              )}
                            </Link>
                          </Box>
                        ) : (
                          // Render image map for single floor
                          <Link onClick={handleClick}>
                            <ImageMapper
                              src={val?.files?.base64}
                              map={val?.imgMarkers}
                              onLoad={() => load()}
                              onClick={(area) => clicked(area, val)}
                              onMouseEnter={(area) =>
                                enterArea(area, val)
                              }
                              onMouseLeave={(area) => leaveArea(area)}
                              responsive={true}
                              disabled={false}
                              stayHighlighted={true}
                              parentWidth={getParentWidth(1000)}
                            />
                            {hoveredArea[val?.floor] && (
                              <Box
                                className="tooltip"
                                style={{
                                  position: "absolute",
                                  backgroundColor: "#577EC6",
                                  color: "#FFFFFF",
                                  // padding: "1%",
                                  borderRadius: "5px",
                                  top:
                                    hoveredArea[val?.floor].center[1] +
                                    165,
                                  left:
                                    hoveredArea[val?.floor].center[0] +
                                    80,
                                }}
                              >
                                <span>
                                  {`Go to summary`}
                                  <br />
                                  {hoveredArea[val?.floor]
                                    ?.roomName && (
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <LabelIcons
                                          bgcolor={"#FFFFFF"}
                                          type={
                                            hoveredArea[val?.floor]?.type
                                          }
                                          size={
                                            hoveredArea[val?.floor]
                                              ?.type === "device"
                                              ? 25
                                              : 18
                                          }
                                        />
                                        {
                                          hoveredArea[val?.floor]
                                            ?.roomName
                                        }
                                      </span>
                                    )}
                                  {hoveredArea[val?.floor]
                                    ?.deviceLocation && (
                                      <span
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <LabelIcons
                                          bgcolor={"#FFFFFF"}
                                          type={
                                            hoveredArea[val?.floor]?.type
                                          }
                                          size={
                                            hoveredArea[val?.floor]
                                              ?.type === "device"
                                              ? 25
                                              : 18
                                          }
                                        />
                                        {
                                          hoveredArea[val?.floor]
                                            ?.deviceLocation
                                        }
                                      </span>
                                    )}
                                </span>
                              </Box>
                            )}
                          </Link>
                        )
                      ) : (
                        // Render alternative component if no floor image is available
                        <>
                          <FloorCardsEmap
                            allData={val}
                            configureListNew={configureListNew}
                            deviceList={deviceList}
                            goToSummaryPage={handleGetSummaryData}
                            locationsList={locationsList}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default MapViewFacility;
